// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M9.48063 2.5H1V21H23V5H11.4806L9.48063 2.5ZM12.6573 11.9988L11.1914 10.4685L12.6356 9.08496L16.3848 12.9988L12.6356 16.9127L11.1914 15.5293L12.6573 13.9988H8V11.9988H12.6573Z"}}]};

const FolderMoveFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'folder-move-filled',
    ref,
    icon: element,
  },
));

FolderMoveFilledIcon.displayName = 'FolderMoveFilledIcon';

export default FolderMoveFilledIcon;
